import moment from 'moment';

const eventList = {
  events: [
    {
      start: moment('20250222'),
      end: moment('20250222'),
      title: 'International Luncheon',
    },
    {
      start: moment('20250322'),
      end: moment('20250322'),
      title: 'Spring Spa & Sip',
    },
    {
      start: moment('20250405'),
      end: moment('20250405'),
      title: 'Wind & Waves Experience',
    },
    {
      start: moment('20250503'),
      end: moment('20250503'),
      title: 'Wind & Waves Experience',
    },
    {
      start: moment('20250612'),
      end: moment('20250612'),
      title: 'Wind & Waves Experience',
    },
  ],
};

export default eventList;